'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createDocumentsReducer = exports.createDocumentReducer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _deserialize = require('../deserialize');

var _deserialize2 = _interopRequireDefault(_deserialize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultHandleFetch = function defaultHandleFetch(state) {
  return _extends({}, state, {
    status: 'fetching'
  });
};

var defaultHandleFailure = function defaultHandleFailure(state) {
  return _extends({}, state, {
    status: 'failed'
  });
};

var defaultHandleSuccess = function defaultHandleSuccess(state, _ref) {
  var data = _ref.data;
  return _extends({}, state, {
    status: 'fetched',
    data: (0, _deserialize2.default)(data)
  });
};

var defaultHandleMultipleSuccess = function defaultHandleMultipleSuccess(state, _ref2) {
  var _ref2$data = _ref2.data,
      data = _ref2$data === undefined ? [] : _ref2$data;
  return _extends({}, state, {
    status: 'fetched',
    data: data.map(function (doc) {
      return (0, _deserialize2.default)(doc);
    })
  });
};

var createDocumentReducer = exports.createDocumentReducer = function createDocumentReducer(namespace) {
  var _handlers;

  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$fetch = options.fetch,
      fetch = _options$fetch === undefined ? defaultHandleFetch : _options$fetch,
      _options$fetchFailure = options.fetchFailure,
      fetchFailure = _options$fetchFailure === undefined ? defaultHandleFailure : _options$fetchFailure,
      _options$fetchSuccess = options.fetchSuccess,
      fetchSuccess = _options$fetchSuccess === undefined ? defaultHandleSuccess : _options$fetchSuccess,
      _options$initialState = options.initialState,
      initialState = _options$initialState === undefined ? {} : _options$initialState;


  var c = {
    FETCH: namespace + '/FETCH',
    FETCH_SUCCESS: namespace + '/FETCH_SUCCESS',
    FETCH_FAILURE: namespace + '/FETCH_FAILURE'
  };

  var handlers = (_handlers = {}, _defineProperty(_handlers, c.FETCH, fetch), _defineProperty(_handlers, c.FETCH_FAILURE, fetchFailure), _defineProperty(_handlers, c.FETCH_SUCCESS, fetchSuccess), _handlers);

  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var _ref3 = arguments[1];
    var type = _ref3.type,
        payload = _ref3.payload;

    var handler = handlers[type];
    return typeof handler === 'function' ? handler(state, payload) : state;
  };
};

var createDocumentsReducer = exports.createDocumentsReducer = function createDocumentsReducer(namespace) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return createDocumentReducer(namespace, _extends({
    fetchSuccess: defaultHandleMultipleSuccess
  }, options));
};


//////////////////
// WEBPACK FOOTER
// ../~/prismic-utils/dist/reducer/index.js
// module id = 1223
// module chunks = 0